import React, { useState, useEffect } from 'react';
import { Tabla } from './Tabla';
import { DragHandleOutlined } from '@mui/icons-material';
import PartnersEditar from '../types/PartnersEditar';
import ObtenerPartners from '../functions/ObtenerPartners';

interface ListarPartnersProps {
    defaultItemsPerPage?: number;
    handleEdit: (partner: PartnersEditar) => void;
    handleDelete: (partner: PartnersEditar) => void;
    handleAdd: () => void
}

export const ListarPartners: React.FC<ListarPartnersProps> = ({ defaultItemsPerPage = 15, handleEdit, handleDelete, handleAdd, }) => {
  
  const [partners, setPartners] = useState<PartnersEditar[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [itemsPerPage, setItemsPerPage] = useState(defaultItemsPerPage);

  useEffect(() => {
    const fetchPartners = async () => {
      try {
        const data = await ObtenerPartners();
        setPartners(data.partners);
        setLoading(false);
      } catch (err) {
        setError('Error al obtener los Partners:' + err);
        setLoading(false);
      }
    };

    fetchPartners();
  }, []);

  const columns = [
    { key: 'id', label: 'ID', align: 'center' as const },
    { key: 'cuit', label: 'CUIT', align: 'left' as const },
    { key: 'razonsocial', label: 'RAZÓN SOCIAL', align: 'left' as const },
    { key: 'domicilio', label: 'DOMICILIO', align: 'left' as const },
    { key: 'habilitado', label: 'HABILITADO', align: 'center' as const },
    { key: 'mostrar_web', label: 'MOSTRAR EN WEB', align: 'center' as const },
    { key: 'dado_baja', label: 'DADO DE BAJA', align: 'center' as const },
  ];

  const handleEditLocal = (partner: PartnersEditar) => {
    handleEdit(partner);
  };

  const handleDeleteLocal = (partner: PartnersEditar) => {
    handleDelete(partner);
  };

  const handleCredencialLocal = (partner: PartnersEditar) => {
    console.log('Mostrar credencial', partner);
  }

  const handleUbicationLocal = (partner: PartnersEditar) => {
    console.log('Mostrar ubicacion', partner);
  };

  if (loading) return <div>Cargando...</div>;
  if (error) return <div>{error}</div>;

  return (
    <div className="container mx-auto px-4 sm:px-6 lg:px-8 mt-5">
      <div className="flex flex-row justify-between items-center mb-3">
        <div className="flex flex-col justify-center items-center">
          <h1 className="font-metropolis text-xl font-bold">Partners cargados</h1>
        </div>
        <div className="flex flex-col justify-center items-center">
          <button className="vp-btn-azul-sm" onClick={handleAdd}>Nuevo Partner</button>
        </div>
      </div>
      <Tabla columns={columns} data={partners} onEdit={handleEditLocal} onDelete={handleDeleteLocal} itemsPerPage={itemsPerPage} onCredencial={handleCredencialLocal} onUbication={handleUbicationLocal} acciones={['editar','eliminar']}/>
    </div>
  );
};